import React from 'react';
import { Query } from '@apollo/client/react/components';

import { SpinnerOverlay } from 'spinner';

import {
  LedgerQuery,
  ReviewHistoryPeriodQuery,
  ReviewHistoryMonthlyQuery,
  BookkeepersQuery,
} from './queries';
import History from './History';

type HistoryContainerProps = {
  clientId: string;
  onStartReview: (restoreLastChecks: boolean, startDate: string, endDate: string) => void;
};

const HistoryContainer = ({ clientId, onStartReview }: HistoryContainerProps) => (
  <Query query={ReviewHistoryPeriodQuery} variables={{ clientId }}>
    {({ loading: periodLoading, error: periodError, data: periodData }: any) => (
      <Query query={ReviewHistoryMonthlyQuery} variables={{ clientId }}>
        {({ loading: monthlyLoading, error: monthlyError, data: monthlyData }: any) => (
          <Query query={LedgerQuery} variables={{ clientId }}>
            {({ loading: ledgerAccountsLoading, error: ledgerAccountsError }) => (
              <Query query={BookkeepersQuery}>
                {({ bookkeepersLoading, error: bookkeepersError }: any) => {
                  if (
                    periodLoading ||
                    ledgerAccountsLoading ||
                    monthlyLoading ||
                    bookkeepersLoading
                  ) {
                    return <SpinnerOverlay />;
                  }

                  const error =
                    (periodError && periodError.message) ||
                    (monthlyError && monthlyError.message) ||
                    (ledgerAccountsError && ledgerAccountsError.message) ||
                    (bookkeepersError && bookkeepersError.message);

                  return (
                    <History
                      periodData={(periodData && periodData.reviewHistoryPeriod) || []}
                      monthlyData={(monthlyData && monthlyData.reviewHistoryMonthly) || []}
                      error={error}
                      onStartReview={onStartReview}
                    />
                  );
                }}
              </Query>
            )}
          </Query>
        )}
      </Query>
    )}
  </Query>
);

export default HistoryContainer;
